module.exports = __webpack_public_path__ + "img/baobiao.273935a0.png";